"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gender = void 0;
exports.gender = { "MALE": { "name": { "code": "MALE", "localize": { "en": "Male", "th": "ชาย", "id": "Laki-laki" } } }, "FEMALE": { "name": { "code": "FEMALE", "localize": { "en": "Female", "th": "หญิง", "id": "Perempuan" } } } };
